import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { fetchEmployeeReport, timeout } from "../Managers/wepApiManager";
import React from "react";
import {
  EmployeeReportModel,
  EnumAlertDialogType,
} from "../Managers/dataStructures";
import {
  ActivityIndicator,
  NegativeToast,
  PositiveToast,
} from "../Managers/utilityComponents";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReportDetailEmployee from "./ReportDetailEmployee";
import {
  processDownloadReport,
  processEmployeeCSVReportForAdmin,
} from "../Managers/processManager";
import { getCurrentCurrency } from "../Managers/profileManager";
import { currentDateFormat, getLanguage } from "../Managers/dataProvider";
import {
  dateToString,
  dateToStringForPicker,
} from "../Managers/utilityFunctions";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFReportAllEmployees from "./PDFReportAllEmployees";

export default function AdminEmployeeReport() {
  //const [width, setWidth] = useState<number>(window.innerWidth);
  const isEnglish = getLanguage();
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [activityIndicator, setActivityIndicator] = useState<boolean>(false);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [csvIndicator, setCSVIndicator] = useState<boolean>(false);
  const [isToastVisible, setIsToastVisible] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );
  const [array_reports, setArrayReports] = React.useState<
    EmployeeReportModel[]
  >([]);
  const [totalMetrics, setTotalMetrics] = React.useState({
    total_hours: "0",
    total_earning: "0",
  });

  useEffect(() => {
    // window.addEventListener("resize", handleWindowSizeChange);
    if (startDate !== undefined && endDate !== undefined) {
      setActivityIndicator(true);
      fetchEmployeeReport(
        startDate,
        endDate,
        (array_items: EmployeeReportModel[]) => {
          setArrayReports(array_items);
          setActivityIndicator(false);
          calculateTotal(array_items);
        }
      );
    }
    // return () => {
    //   window.removeEventListener("resize", handleWindowSizeChange);
    // };
  }, [startDate, endDate]);

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  //   //console.log("width=" + window.innerWidth);
  // }

  const startDateString: string = dateToString(startDate);
  const endDateString: string = dateToString(endDate);
  const startDateStringForPicker: string = dateToStringForPicker(startDate);
  const endDateStringForPicker: string = dateToStringForPicker(endDate);
  const reportName: string =
    "Report All Employees-From " +
    startDateString +
    " to " +
    endDateString +
    ".pdf";

  function calculateTotal(array_item: EmployeeReportModel[]) {
    let temp_hours: number = 0;
    let total_earning: number = 0;
    for (let i = 0; i < array_item.length; i++) {
      temp_hours += array_item[i].total_time_in_seconds;
      total_earning += array_item[i].total_earning;
    }
    let totalSeconds: number = temp_hours;
    const hrs: number = Math.trunc(totalSeconds / 3600);
    const mins: number = Math.trunc((totalSeconds - hrs * 3600) / 60);
    const remainingSeconds: number = totalSeconds - (hrs * 3600 + mins * 60);
    // const total_hours: string =
    //   (hrs > 0 ? hrs + " hrs : " : "") +
    //   (mins > 0
    //     ? mins + " mins : " + remainingSeconds + " secs"
    //     : remainingSeconds + " secs");
    const total_hours: string =
      (hrs > 0 ? hrs + (isEnglish ? " hrs : " : " Std : ") : "") +
      (mins > 0
        ? mins +
          (isEnglish ? " mins : " : " min : ") +
          remainingSeconds +
          (isEnglish ? " secs" : " sek")
        : remainingSeconds + (isEnglish ? " secs" : " sek"));
    setTotalMetrics({
      total_hours: total_hours,
      total_earning: getCurrentCurrency() + " " + total_earning.toFixed(0),
    });
  }
  function onStartDateChange(x: dayjs.Dayjs | null) {
    setStartDate(x?.toDate() as Date);
  }

  function onEndDateChange(x: dayjs.Dayjs | null) {
    setEndDate(x?.toDate() as Date);
  }

  async function onDownload() {
    setIsRunning(true);
    onCreatePDF();
    await processDownloadReport();
    showAlert(true);
    setIsRunning(false);
  }

  async function onDownloadCSV() {
    setCSVIndicator(true);
    downloadCSV();
    await processDownloadReport();
    showAlert(true);
    setCSVIndicator(false);
  }

  function downloadCSV() {
    const reportName: string =
      "Report All Employees-From " +
      startDateString +
      " to " +
      endDateString +
      ".csv";
    const element = document.createElement("a");
    const file = new Blob(
      [
        processEmployeeCSVReportForAdmin(
          array_reports,
          startDateString,
          endDateString
        ),
      ],
      {
        type: "text/plain; charset=UTF-32",
      }
    );
    element.href = URL.createObjectURL(file);
    element.download = reportName;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  function onCreatePDF() {
    const planName: string =
      "Report All Employees-From " +
      startDateString +
      " to " +
      endDateString +
      ".pdf";
    const input = document.getElementById("divToPrint");
    let formatHeight: number = 4;
    formatHeight = array_reports.length * 100;
    if (input !== null) {
      html2canvas(input).then((canvas) => {
        //const imgData = canvas.toDataURL("image/png");
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: "a4",
        });
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        console.log(
          "log w=" +
            imgProps.width +
            " h=" +
            imgProps.height +
            " pdfw=" +
            pdf.internal.pageSize.getWidth() +
            " pdfh=" +
            pdfHeight
        );
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(planName);

        // const pdf = new jsPDF({
        //   orientation: formatHeight < 500 ? "landscape" : "portrait",
        //   unit: "px",
        //   format: [500, formatHeight / 1.5],
        // });
        // pdf.addImage(
        //   imgData,
        //   "JPEG",
        //   0,
        //   0,
        //   500,
        //   formatHeight / 2,
        //   planName,
        //   "SLOW"
        // );
        // pdf.save(planName);
      });
    }
  }

  async function showAlert(isPositive: boolean) {
    if (isPositive) {
      setIsToastVisible(EnumAlertDialogType.POSITIVE);
    } else {
      setIsToastVisible(EnumAlertDialogType.NEGATIVE);
    }
    await timeout(3000);
    setIsToastVisible(EnumAlertDialogType.NEUTRAL);
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish
              ? "Report : All Employees"
              : "Arbeitszeiten alle Mitarbeiterseite"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "Report of All Employees, their working hours and salaries in selected time span."
              : "Die Übersicht zeigt alle Mitarbeiter, die im ausgewählten Zeitraum gearbeitet haben. Sie enthält ihre Arbeitsstunden sowie das Ergebnis aus Arbeitszeit und Stundenlohn."}
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none"></div>
      </div>
      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="px-8 mt-4 sm:flex mr-5">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label={isEnglish ? "From" : "Von"}
                  disableFuture
                  format={currentDateFormat()}
                  onAccept={(x) => onStartDateChange(x)}
                  defaultValue={dayjs(startDateStringForPicker)}
                  disabled={activityIndicator}
                />
              </DemoContainer>
            </LocalizationProvider>
            <div className="mx-2">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label={isEnglish ? "To" : "Bis"}
                    disableFuture
                    format={currentDateFormat()}
                    onAccept={(x) => onEndDateChange(x)}
                    defaultValue={dayjs(endDateStringForPicker)}
                    disabled={activityIndicator}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </div>
          {activityIndicator === true ? (
            <div className="mt-5 flex items-center justify-center">
              {ActivityIndicator(1)}
            </div>
          ) : array_reports.length === 0 ? (
            <div className="mt-10 flex justify-center font-semibold">
              {isEnglish ? "No Report Available" : "Keine Daten verfügbar"}
            </div>
          ) : (
            <div>
              <div className="mt-4 mx-8 sm:mt-0 sm:flex-none flex items-center gap-x-6">
                <PDFDownloadLink
                  document={
                    <PDFReportAllEmployees
                      array_reports={array_reports}
                      startDateString={startDateString}
                      endDateString={endDateString}
                      total_hours={totalMetrics.total_hours}
                      total_salary={totalMetrics.total_earning}
                    />
                  }
                  fileName={reportName}
                >
                  <button
                    type="button"
                    //onClick={onDownload}
                    className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    {isRunning === true ? ActivityIndicator(0) : null}
                    Download PDF
                  </button>
                </PDFDownloadLink>
                <button
                  type="button"
                  onClick={onDownloadCSV}
                  className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  {csvIndicator === true ? ActivityIndicator(0) : null}
                  Download CSV
                </button>
              </div>
              <div id="divToPrint" className="mx-8">
                <div className="mt-5 px-2 sm:px-2 lg:px-2">
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {isEnglish
                      ? "Report : All Employees"
                      : "Berichte: Mitarbeiter"}
                  </label>
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {(isEnglish ? "From: " : "Von: ") + startDateString}
                  </label>
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {(isEnglish ? "To: " : "Bis: ") + endDateString}
                  </label>
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {(isEnglish ? "Total hours: " : "Gesamtarbeitsstunden: ") +
                      totalMetrics.total_hours}
                  </label>
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {(isEnglish ? "Total salary: " : "Gesamt Verdienst: ") +
                      totalMetrics.total_earning}
                  </label>
                </div>
                <div className="col-span-full mt-4">
                  {isToastVisible === EnumAlertDialogType.NEUTRAL
                    ? null
                    : isToastVisible === EnumAlertDialogType.POSITIVE
                    ? PositiveToast(
                        isEnglish
                          ? "Report Downloaded"
                          : "Bericht heruntergeladen"
                      )
                    : NegativeToast(
                        isEnglish
                          ? "Error: Unable to process request."
                          : "Fehler: Anfrage kann nicht verarbeitet werden."
                      )}
                </div>
                {activityIndicator ? (
                  <div className="mt-5 flex items-center justify-center">
                    {ActivityIndicator(1)}
                  </div>
                ) : null}
                <div>
                  <ReportDetailEmployee array_reportDetail={array_reports} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
